// extracted by mini-css-extract-plugin
export var alertIcon = "_sd-0";